import { Injectable } from '@angular/core';
import { RequestService } from '@core/services/request/request.service';
import { Observable } from 'rxjs';
import { RequestResponse } from '@core/services/request/model/request.model';
import { ApiDirectory } from '@core/api/api-directory';
import { AnnouncementApi } from '@core/api/model/notifications/announcement-api.model';
import { LoadingIds } from '@shared/constants/loading';
import { HttpEvent } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ApiAnnouncementService {
  constructor(private readonly _request: RequestService) {}

  updateAnnouncements(): Observable<RequestResponse<boolean>> {
    return this._request.post(ApiDirectory.Notificaciones.AvisosAcciona({}), null, {
      loading: LoadingIds.UPDATE_ANNOUNCEMENTS,
    });
  }

  fetchAnnouncement(guidAviso: string): Observable<RequestResponse<AnnouncementApi>> {
    return this._request.get(ApiDirectory.Notificaciones.ContenidoAvisoAcciona({ guidAviso }), {
      loading: LoadingIds.FETCH_ANNOUNCEMENT,
    });
  }

  downloadDocument(documentUrl: string): Observable<HttpEvent<Blob>> {
    return this._request.downloadWithProgress(
      ApiDirectory.Notificaciones.DocumentoAvisoAcciona({ urlDocumento: encodeURIComponent(documentUrl) })
    );
  }
}
